import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "@i18n";
import { useParams, useSearchParams } from "react-router-dom";
import { qs } from "url-parse";
import Layout from "@/_LayoutsRelated/layout/Layout";
import Button from "../../../components/UiKit/Button/Button";
import Disclaimer from "@/_MiniApps/Disclaimer/Disclaimer";
import { cashCheckout1Event, finanaceButtonClickedEvents } from "@/utils/dataLayerEvents";
import { trackEvents } from "@/common/events/events";
import { useIsMobile } from "@/common/Contexts/IsMobileContext";
import useHelpers from "@hooks/useHelpers";
import Loader from "@componentsShared/Loader/Loader";
import fetcher from "@/common/axiosInstance";
import { PURCHASE_METHOD_AMWAL, PURCHASE_METHOD_ARIB, PURCHASE_METHOD_CASH, PURCHASE_METHOD_CREDIT_CARD, PURCHASE_METHOD_NORMAL_FINANCE, PURCHASE_METHOD_TABBY, PURCHASE_METHOD_TAMRA, useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import PreCheckoutPaymentSectionsRenderer from "@/pages/checkout/pre-checkout/PreCheckoutPaymentSectionsRenderer";
import useBoolean from "@hooks/useBoolean";
import PreCheckoutFAQs from "@/pages/checkout/pre-checkout/PreCheckoutFAQs";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import CarSpecsHeader from "@/pages/split-payment/components/CarSpecsHeader";
import SplitPaymentDetails from "@/pages/split-payment/components/SplitPaymentDetails";
import MobileCarInfoPhotoV2 from "@/pages/checkout/components/HeadingSteps/MobileCarInfo/MobileCarInfoPhotoV2";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import { CDN_LINK } from "@globalConfig";
import { showAppToast } from "@/components/ui/app-toast";
import { Icon } from "@syarahtech/ui";
var PreCheckout = function PreCheckout() {
  var _checkoutOrderV2$post2, _checkoutOrderV2$paym, _checkoutOrderV2$deta, _checkoutOrderV2$fina, _checkoutOrderV2$post3, _checkoutOrderV2$post4, _checkoutOrderV2$g4_d11, _checkoutOrderV2$stor, _checkoutOrderV2$stor2;
  if (__IS_SSR__) return /*#__PURE__*/React.createElement(Loader, null);
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateBack = _useHelpers.navigateBack,
    navigateToHard = _useHelpers.navigateToHard;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var isMobile = useIsMobile();
  var isDesktop = !isMobile;
  // Most links use `/pre-checkout/:postId`, but the BNPL back buttons still use
  // the `?post_id=` query form — accept both so a query-string link doesn't send
  // post_id=NaN to the API.
  var _useParams = useParams(),
    postIdParam = _useParams.postId;
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var post_id = postIdParam || searchParams.get("post_id") || undefined;
  var _useState = useState(null),
    event = _useState[0],
    setEvent = _useState[1];
  var _useState2 = useState(null),
    selectedSplitPaymentUrl = _useState2[0],
    setSelectedSplitPaymentUrl = _useState2[1];
  var _useCheckoutOrder$sta = useCheckoutOrder().state,
    checkoutOrderV2 = _useCheckoutOrder$sta.checkoutOrderV2,
    fetch_loading = _useCheckoutOrder$sta.fetch_loading;
  var purchaseMethod = useCheckoutOrder().state.purchaseMethod;
  var fetch__getOrderWithPaymentInfoV2 = useCheckoutOrder().remote_actions.fetch__getOrderWithPaymentInfoV2;
  var grantedPopup = useBoolean();
  var _useSession = useSession(),
    user = _useSession.user,
    isLoggedIn = _useSession.isLoggedIn;
  var _useState3 = useState({}),
    rejectionItems = _useState3[0],
    setRejectionItems = _useState3[1];
  useEffect(function () {
    fetch__getOrderWithPaymentInfoV2(Number(post_id));
  }, [post_id]);
  useEffect(function () {
    var _checkoutOrderV2$post, _bnplSection$items;
    if (!(checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && checkoutOrderV2.paymentMethodSections) || !(checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && (_checkoutOrderV2$post = checkoutOrderV2.post) !== null && _checkoutOrderV2$post !== void 0 && _checkoutOrderV2$post.post_id)) return;
    var bnplSection = checkoutOrderV2.paymentMethodSections.find(function (s) {
      return s.method_type === "bnpl";
    });
    var itemsWithPreScoring = ((_bnplSection$items = bnplSection === null || bnplSection === void 0 ? void 0 : bnplSection.items) !== null && _bnplSection$items !== void 0 ? _bnplSection$items : []).filter(function (item) {
      var _item$state;
      return item.pre_scoring_endpoint && ((_item$state = item.state) === null || _item$state === void 0 ? void 0 : _item$state.enabled) !== false;
    });
    if (!itemsWithPreScoring.length) return;
    if (!isLoggedIn) {
      var eligible = {};
      itemsWithPreScoring.forEach(function (item) {
        eligible[item.method_type] = null;
      });
      setRejectionItems(eligible);
      return;
    }
    var postId = Number(checkoutOrderV2.post.post_id);
    var phone = user.phone_number;
    var updates = {};
    var promises = itemsWithPreScoring.map(function (item) {
      return fetcher().post("/".concat(item.pre_scoring_endpoint), {
        post_id: postId,
        phone_number: phone
      }).then(function (res) {
        var _res$data, _data$item;
        var data = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data;
        updates[item.method_type] = data !== null && data !== void 0 && data.rejection_reason ? (_data$item = data.item) !== null && _data$item !== void 0 ? _data$item : null : null;
      })["catch"](function () {
        updates[item.method_type] = null;
      });
    });
    Promise.all(promises).then(function () {
      return setRejectionItems(function (prev) {
        return _objectSpread(_objectSpread({}, prev), updates);
      });
    });
  }, [checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post2 = checkoutOrderV2.post) === null || _checkoutOrderV2$post2 === void 0 ? void 0 : _checkoutOrderV2$post2.post_id, isLoggedIn, user === null || user === void 0 ? void 0 : user.phone_number]);
  var handleContinue = function handleContinue() {
    switch (purchaseMethod) {
      case PURCHASE_METHOD_CASH:
        return navigateTo("/checkout/shop-apply?post_id=".concat(post_id));
      case PURCHASE_METHOD_CREDIT_CARD:
        return navigateTo("/checkout/credit-card?post_id=".concat(post_id));
      case PURCHASE_METHOD_NORMAL_FINANCE:
        return navigateTo("/finance-apply-free/".concat(post_id, "?").concat(qs.stringify({
          financestep: 1
        })));
      case PURCHASE_METHOD_TAMRA:
        return navigateTo("/finance-apply-tamara?post_id=".concat(post_id));
      case PURCHASE_METHOD_ARIB:
        return navigateTo('/finance-apply-arib', {
          post_id: post_id
        });
      case PURCHASE_METHOD_TABBY:
        return navigateTo("/finance-apply-tabby?post_id=".concat(post_id));
      case PURCHASE_METHOD_AMWAL:
        return navigateTo("/finance-apply-amwal?post_id=".concat(post_id));
      default:
        return;
    }
  };
  var handleContinueClick = function handleContinueClick() {
    var _checkoutOrderV2$g4_d6, _checkoutOrderV2$g4_d7, _checkoutOrderV2$g4_d8, _checkoutOrderV2$g4_d9, _checkoutOrderV2$g4_d0;
    if (isContinueDisabled) {
      showAppToast(tShort("pre-checkout/toast_choose_method", {
        ns: "web_pre_checkout"
      }), {
        id: "precheckout-choose-method",
        className: "md:mt-[80px]"
      });
      return;
    }
    if (selectedSplitPaymentUrl) {
      var _checkoutOrderV2$g4_d, _checkoutOrderV2$g4_d2, _checkoutOrderV2$g4_d3, _checkoutOrderV2$g4_d4, _checkoutOrderV2$g4_d5;
      trackEvents("checkout", _objectSpread(_objectSpread({}, checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d === void 0 ? void 0 : _checkoutOrderV2$g4_d.g4_data_layer), {}, {
        booking_type: "split_payment",
        post_trim: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d2 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d3 = _checkoutOrderV2$g4_d2.g4_data_layer) === null || _checkoutOrderV2$g4_d3 === void 0 ? void 0 : _checkoutOrderV2$g4_d3.post_ext,
        from_finance_calculator: false,
        inventory_type_string: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d4 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d4 === void 0 ? void 0 : (_checkoutOrderV2$g4_d5 = _checkoutOrderV2$g4_d4.g4_data_layer) === null || _checkoutOrderV2$g4_d5 === void 0 ? void 0 : _checkoutOrderV2$g4_d5.inventory_type_string
      }));
      navigateToHard(selectedSplitPaymentUrl);
      return;
    }
    var booking_type = null;
    if (purchaseMethod === PURCHASE_METHOD_CASH) {
      booking_type = "cash";
    } else if (purchaseMethod === PURCHASE_METHOD_NORMAL_FINANCE) {
      booking_type = "finance";
    } else if (purchaseMethod === PURCHASE_METHOD_ARIB) {
      booking_type = 'finance';
    } else if (purchaseMethod === PURCHASE_METHOD_TAMRA) {
      booking_type = "tamara";
    } else if (purchaseMethod === PURCHASE_METHOD_TABBY) {
      booking_type = "tabby";
    } else if (purchaseMethod === PURCHASE_METHOD_AMWAL) {
      booking_type = "amwal";
    } else if (purchaseMethod === PURCHASE_METHOD_CREDIT_CARD) {
      booking_type = "credit_card";
    }
    trackEvents("checkout", _objectSpread(_objectSpread({}, checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d6 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d6 === void 0 ? void 0 : _checkoutOrderV2$g4_d6.g4_data_layer), {}, {
      booking_type: booking_type,
      post_trim: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d7 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d7 === void 0 ? void 0 : (_checkoutOrderV2$g4_d8 = _checkoutOrderV2$g4_d7.g4_data_layer) === null || _checkoutOrderV2$g4_d8 === void 0 ? void 0 : _checkoutOrderV2$g4_d8.post_ext,
      from_finance_calculator: false,
      inventory_type_string: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d9 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d9 === void 0 ? void 0 : (_checkoutOrderV2$g4_d0 = _checkoutOrderV2$g4_d9.g4_data_layer) === null || _checkoutOrderV2$g4_d0 === void 0 ? void 0 : _checkoutOrderV2$g4_d0.inventory_type_string
    }));
    if (event === "finance") {
      var _checkoutOrderV2$g4_d1;
      finanaceButtonClickedEvents(null, checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d1 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d1 === void 0 ? void 0 : _checkoutOrderV2$g4_d1.g4_data);
    } else {
      var _checkoutOrderV2$g4_d10;
      cashCheckout1Event("checkout_lead", checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d10 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d10 === void 0 ? void 0 : _checkoutOrderV2$g4_d10.g4_data);
    }
    handleContinue();
  };
  var isContinueDisabled = !purchaseMethod && !selectedSplitPaymentUrl;
  var continueButton = /*#__PURE__*/React.createElement(Button, {
    id: "precheckout-proceed-btn",
    onClick: handleContinueClick,
    className: "!bg-[#0D0DB5] !mb-4 !w-full disabled:!border-[#d6dfe9] disabled:!bg-[#ebebeb] disabled:!text-[#d6dfe9] disabled:cursor-not-allowed"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex items-center justify-center gap-2"
  }, t("next", {
    ns: "web_common"
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-left-alt-rounded",
    className: "en:rotate-180",
    width: 6,
    height: 6
  })));
  var desktopContinueButton = /*#__PURE__*/React.createElement(Button, {
    id: "precheckout-proceed-btn-desktop",
    onClick: handleContinueClick,
    className: "!w-full !bg-primary-new"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex items-center justify-center gap-2"
  }, t("next", {
    ns: "web_common"
  }), /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-left-alt-rounded",
    className: "en:rotate-180",
    width: 6,
    height: 6
  })));
  var paymentRenderer = /*#__PURE__*/React.createElement(PreCheckoutPaymentSectionsRenderer, {
    sections: (_checkoutOrderV2$paym = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.paymentMethodSections) !== null && _checkoutOrderV2$paym !== void 0 ? _checkoutOrderV2$paym : [],
    loading: fetch_loading,
    salePrice: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$deta = checkoutOrderV2.detail) === null || _checkoutOrderV2$deta === void 0 ? void 0 : _checkoutOrderV2$deta.sale_price,
    financeSteps: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$fina = checkoutOrderV2.finance) === null || _checkoutOrderV2$fina === void 0 ? void 0 : _checkoutOrderV2$fina.financeSteps,
    postIsNew: !!(checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && (_checkoutOrderV2$post3 = checkoutOrderV2.post) !== null && _checkoutOrderV2$post3 !== void 0 && _checkoutOrderV2$post3.post_is_new),
    postId: checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && (_checkoutOrderV2$post4 = checkoutOrderV2.post) !== null && _checkoutOrderV2$post4 !== void 0 && _checkoutOrderV2$post4.post_id ? Number(checkoutOrderV2.post.post_id) : undefined,
    g4Data: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d11 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d11 === void 0 ? void 0 : _checkoutOrderV2$g4_d11.g4_data_layer,
    rejectionItems: rejectionItems,
    selectedSplitPaymentUrl: selectedSplitPaymentUrl,
    onSplitPaymentSelected: setSelectedSplitPaymentUrl,
    cashStory: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$stor = checkoutOrderV2.story) === null || _checkoutOrderV2$stor === void 0 ? void 0 : (_checkoutOrderV2$stor2 = _checkoutOrderV2$stor.story_section) === null || _checkoutOrderV2$stor2 === void 0 ? void 0 : _checkoutOrderV2$stor2.cash_story
  });
  return /*#__PURE__*/React.createElement(Layout, {
    hideBurgerMenu: isMobile,
    hideFooter: true,
    hideOrangeHeadBtn: true,
    headHideLinks: true,
    hideAppBanner: true,
    straightHeader: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement("div", {
      className: "relative flex h-[50px] w-full shrink-0 items-center justify-between bg-[#f4f7fb] px-4 pt-2"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      "aria-label": "back",
      className: "shrink-0 border-none bg-transparent",
      onClick: navigateBack
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "material-symbols--chevron-right-rounded",
      className: "en:rotate-180 text-[#0D0DB5]",
      width: 6,
      height: 6
    })), /*#__PURE__*/React.createElement("span", {
      className: "w-6 shrink-0 opacity-0"
    }), /*#__PURE__*/React.createElement("strong", {
      className: "pointer-events-none absolute left-1/2  w-[197px] -translate-x-1/2 text-center text-sm font-bold leading-6 text-[#020202]"
    }, tShort("pre-checkout/mobile_page_title", {
      ns: "web_pre_checkout"
    })))
  }, isMobile && /*#__PURE__*/React.createElement("div", {
    className: "h-4 w-full bg-[#f4f7fb]"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col justify-start md:justify-between md:!w-[63%] md:mx-auto md:!pt-4 ".concat(isMobile ? "!pt-5 max-w-[2000px] w-[92%] mx-auto" : "container")
  }, isDesktop && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-7 pt-6"
  }, /*#__PURE__*/React.createElement(CarSpecsHeader, {
    checkoutOrderV2: checkoutOrderV2
  }), /*#__PURE__*/React.createElement("div", {
    className: "overflow-hidden rounded-2xl border border-solid border-[#e1e8f2] bg-white shadow-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex min-w-0 flex-[602] flex-col gap-6 px-6 py-8"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-start text-xl font-bold text-[#00143c]"
  }, t("choose_purchase_method", {
    ns: "web_pre_checkout"
  })), paymentRenderer, /*#__PURE__*/React.createElement("div", {
    className: "pt-2"
  }, desktopContinueButton)), /*#__PURE__*/React.createElement("div", {
    className: "flex min-w-0 flex-[486] shrink-0 flex-col gap-6 px-6 py-8 self-stretch"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-start text-xl font-bold text-[#00143c]"
  }, tShort("flexible_payment/details_title")), /*#__PURE__*/React.createElement(SplitPaymentDetails, {
    checkoutOrderV2: checkoutOrderV2,
    loading: fetch_loading,
    hidePaymentMethodHeader: true,
    showWarrantySection: false,
    warrantyCollapsed: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: "m-show mt-10"
  }, /*#__PURE__*/React.createElement(Disclaimer, {
    className: ""
  })), /*#__PURE__*/React.createElement(PreCheckoutFAQs, null)), isMobile && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 pb-40"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3"
  }, paymentRenderer), /*#__PURE__*/React.createElement(PreCheckoutFAQs, null))), isMobile && /*#__PURE__*/React.createElement(motion.div, {
    className: "fixed bottom-0 left-0 right-0 z-50 flex flex-col gap-3 rounded-t-2xl bg-white px-4 pb-6 pt-3 shadow-[0px_-1px_2px_0px_rgba(0,0,0,0.08)]",
    initial: {
      y: "100%"
    },
    animate: {
      y: 0
    },
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 30
    }
  }, /*#__PURE__*/React.createElement(MobileCarInfoPhotoV2, {
    checkoutOrderV2: checkoutOrderV2,
    onClickInfoIcon: grantedPopup.setTrue
  }), continueButton), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: grantedPopup.value,
    onClose: grantedPopup.setFalse,
    containerClassName: "!z-[999999999]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center gap-8 p-[13px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/infoOrange.svg",
    width: "96px",
    height: "82px",
    alt: "icon"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-blue-indigo text-center text-[32px] font-bold leading-[32px]"
  }, t("shipping_cost_2", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-blue-indigo text-center font-[Cairo] text-[20px] font-semibold leading-[32px]"
  }, t("shipping_cost_determined_sales_representative", {
    ns: "web_checkout_cash"
  })))));
};
export default PreCheckout;